import { observable } from 'mobx'
import React, { Component } from 'react'
import {
  checkoutContainer,
  customerContainer,
  storeContainer,
} from 'src/models'
import { IS_BROWSER, isExpressCheckout, getLocaleCodeFromUrl } from 'src/utils'
import './styles.scss'

class PayLaterMessage extends Component {
  @observable paypaltoken = ' '

  constructor(props) {
    super(props)
  }

  initPaylaterMount = async () => {
    if (!this.paypaltoken?.token) {
      this.paypaltoken = await checkoutContainer.getPayPalToken()
    }
    const onPaypalLoadSDK = (paypalCheckoutErr, paypalCheckoutInstance) => {
      /**
       * @description
       * Stop if there was a problem creating PayPal Checkout.
       * This could happen if there was a network error or if it's incorrectly configured.
       */
      if (paypalCheckoutErr) {
        console.error('Error creating PayPal Checkout:', paypalCheckoutErr)
        return
      }

      const localeCode = getLocaleCodeFromUrl() || 'en_US'
      // Extract country code from locale (en_US -> US, en_AU -> AU)
      const buyerCountry = localeCode.includes('_')
        ? localeCode.split('_')[1]
        : 'US'

      const currency =
        storeContainer?.activeStoreResponse?.defaultCurrency || 'USD'
      paypalCheckoutInstance?.loadPayPalSDK(
        {
          components: 'buttons,messages',
          'enable-funding': 'paylater',
          currency: currency,
        },
        function () {
          const button = paypal?.Buttons({
            fundingSource: paypal?.FUNDING.PAYLATER,
          })
          //button.render('#pay-later-button')
        }
      )
    }

    const createPaypalCheckout = clientInstance => {
      // Create a PayPal Checkout component.
      braintree?.paypalCheckout?.create(
        {
          client: clientInstance,
        },
        function (paypalCheckoutErr, paypalCheckoutInstance) {
          onPaypalLoadSDK(paypalCheckoutErr, paypalCheckoutInstance)
        }
      )
    }

    const createPayPalCheckoutComponent = (clientErr, clientInstance) => {
      /**
       * @description
       * Stop if there was a problem creating the client.
       * This could happen if there is a network error or if the authorization
       * is invalid.
       */
      if (clientErr) {
        console.error('Error creating client:', clientErr)
        return
      }
      createPaypalCheckout(clientInstance)
    }

    // after braintree is also ready
    // after dom is ready
    if (typeof braintree !== 'undefined' && braintree?.client) {
      /**
       * @note
       * where we creating braintree instance
       *
       */

      braintree?.client?.create(
        {
          authorization: this.paypaltoken?.token,
        },
        function (clientErr, clientInstance) {
          createPayPalCheckoutComponent(clientErr, clientInstance)
        }
      )
    } else {
      console.log('paylater no braintree ')
    }
  }

  checkAndInitPaylater = () => {
    const customerResponse =
      customerContainer?.profileResponse?.customer ||
      customerContainer?.profileResponse
    if (IS_BROWSER) {
      if (
        customerResponse?.id &&
        typeof braintree !== 'undefined' &&
        braintree?.client
      ) {
        this.initPaylaterMount()
      } else {
        // used timer since we don't have direct connection between customer and product state
        setTimeout(() => {
          this.checkAndInitPaylater()
        }, 300)
      }
    }
  }
  componentDidMount() {
    this.checkAndInitPaylater()
  }

  componentDidUpdate = prevProps => {
    try {
      if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
      } else {
        if (isExpressCheckout()) {
          this.handleExpressCheckoutPaypalInit()
        }
      }
    } catch (e) {
      console.log('paylater parse error', e)
    }
  }

  handleExpressCheckoutPaypalInit() {
    if (
      !checkoutContainer.showExpressCheckoutDrawer &&
      IS_BROWSER &&
      !document
        .getElementById(this.props.id || 'paylater_id')
        ?.hasChildNodes?.()
    ) {
      this.checkAndInitPaylater()
    }
  }

  render() {
    const localeCode = getLocaleCodeFromUrl() || 'en_US'
    // Extract country code from locale (en_US -> US, en_AU -> AU)
    const buyerCountry = localeCode.includes('_')
      ? localeCode.split('_')[1]
      : 'US'

    return (
      <div
        data-pp-message
        data-pp-placement="product"
        data-pp-layout="text"
        data-pp-text-color="black"
        data-pp-logo-type="inline"
        data-pp-amount={this.props?.amount || ''}
        data-pp-buyercountry={buyerCountry}
        className={'paylater-wrapper'}
        id={this.props.id || 'paylater_id'}
        data-testid="qa-pdp-paypal-message"></div>
    )
  }
}
export { PayLaterMessage }
